import { JetView } from 'webix-jet'; // Importing JetView for creating a Webix view
import { getCities } from 'models/cities'; // Importing function to get cities data
import { getTags } from 'models/tags'; // Importing function to get tags data
import { getPositions } from 'models/positions'; // Importing function to get positions data
import 'webix/photo'; // Importing Webix photo module
import 'webix/tinymce/tinymce'; // Importing TinyMCE editor for Webix

/**
 * Class representing the filter view for casino reports.
 * @extends JetView
 */
export default class FilterInformeCasinoView extends JetView {
    /**
     * Configures the layout of the filter view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Screen size configuration

        // Left section containing date picker
        const left = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text', // Datepicker input
                    name: 'Datepicker',
                    id: 'Datepicker',
                    css: 'reportrange',
                    readonly: true, // Read-only input
                    value: moment().subtract(0, 'days').format('YYYY-MM-DD') + ' - ' + moment().format('YYYY-MM-DD'), // Default date range
                    label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'), // Label for datepicker
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '), // Placeholder text
                },
            ],
        };

        // Center left section containing country selection
        const center_left = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'richselect', // Dropdown for country selection
                    name: 'CountrySelect',
                    localId: 'regions:combo',
                    label: _('País'), // Label for country select
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '), // Placeholder text
                    options: [], // Options will be populated dynamically
                },
            ],
        };

        // Center right section containing currency selection
        const center_right = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'richselect', // Dropdown for currency selection
                    name: 'CurrencySelect',
                    localId: 'currencies:combo',
                    label: "<span class='webix_icon mdi mdi-coin'></span>" + _('Moneda'), // Label for currency select
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '), // Placeholder text
                    options: [], // Options will be populated dynamically
                },
            ],
        };

        // Right section (currently empty)
        const right = {
            margin: 5,
            minWidth: 200,
            rows: [],
        };

        // Upper section containing the main filter inputs
        const upper_section = {
            id: 'a1',
            rows: [
                {
                    responsive: 'a1',
                    margin: 10,
                    cols: [left, center_left, center_right, right], // Layout of columns
                },
            ],
        };

        // Button section for actions
        const buttons = {
            margin: 10,
            cols: [
                {},
                {
                    view: 'button', // Clear button
                    value: _('Limpiar'),
                    autowidth: true,
                    click: () => {
                        this.getRoot().clear(); // Clears the form inputs
                    },
                },
                {
                    view: 'button', // Consult button
                    value: _('Consultar'),
                    type: 'form',
                    autowidth: true,
                    click: () => {
                        const filterdata = this.getRoot().getValues(); // Get form values
                        this.app.callEvent('flujoCajaResumido:filter', [
                            filterdata, // Trigger filter event with form data
                        ]);
                    },
                },
            ],
        };

        // Return the complete form configuration
        return {
            view: 'form',
            rows: [upper_section, buttons], // Combine upper section and buttons
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for form fields
            },
        };
    }
}

// FILE DOCUMENTED
